import { getResolvedPackageName } from './packageIdentity'

/** Zivano 测试包、正式包。其余 packageName（含 Donia、空值）都不是 Zivano。 */
const ZIVANO_PACKAGE_NAMES = ['com.dd.dddd.debug', 'com.zivano.live'] as const

const ZIVANO_DISPLAY_NAME = 'Zivano'

export function isZivano(packageName?: string | null): boolean {
  const name = packageName ?? getResolvedPackageName() ?? ''
  return (ZIVANO_PACKAGE_NAMES as readonly string[]).includes(name)
}

/** 原生导航标题和文案 {{APP}}。Zivano 用品牌名，其余沿用编译期展示名。 */
export function getAppDisplayName(packageName?: string | null): string {
  if (isZivano(packageName)) return ZIVANO_DISPLAY_NAME
  return process.env.REACT_APP_DISPLAY_NAME || 'Donialive'
}
